import { call } from "./use"

export const useClickOutside = (controller, options = {}) => {
  const controllerDisconnect = controller.disconnect.bind(controller)
  const targetElement = options?.element || controller.element

  const handleClickOutside = ({target}) => {
    if(targetElement.contains(target)) return;
    call(controller, 'clickedOutside')
  }

  document.addEventListener('click', handleClickOutside);

  Object.assign(controller, {
    disconnect() {
      document.removeEventListener('click', handleClickOutside);
      controllerDisconnect()
    }
  })
}
